import {Component,Input, OnInit, OnChanges,SimpleChanges,AfterViewInit} from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router'; 
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar'; 
/**
 * La Class MenuGenRecursiveComponent.
 * <ul>
 * <li>Copyright 2022 SUNEDU -
 * SUNEDU. Todos los derechos reservados.</li>
 * </ul>
 *
 * @author BVEGAL
 * @version 1.0, Thu Aug 19 10:39:15 COT 2022
 * @since SUNEDU-REUNIONES-CORE 1.0
 */
@Component({
  selector: 'app-menugenrecursive',
  templateUrl: './menugenrecursive.component.html',
  styleUrls: ['./app-layout.component.scss'] 
})
export class MenuGenRecursiveComponent  implements  OnInit, OnChanges,AfterViewInit {
    
	@Input("navMenuItems")
	public navMenuItems  = [];

	constructor(public dialog: MatDialog, public snackbar: MatSnackBar,public router : Router,public route:  ActivatedRoute
	  ) {  
	}
	
	ngAfterViewInit() {
    // viewChild is set after the view has been initialized
	}

    ngOnChanges(changes: SimpleChanges) { 
    }
	
	ngOnInit() {
		this.onInit();
	}
	 
	onInit() {
    /*var id = this.route.params.subscribe(params => {
      var id = params['id'];

    });*/
    }
  
	openOpcion(opcion : any) {
		console.log("openOpcion.id==> " + opcion.id);
		console.log("openOpcion.checked==> " + opcion.checked);
		opcion.checked = !opcion.checked;
		console.log("openOpcion.checked.new==> " + opcion.checked); 
	  }

	 
}

  
